module.exports = __webpack_public_path__ + "static/mobile-bg-3a31bb6c8603d23ea08f3954f440c37e.gif";